import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useApi } from '../../context/ApiContext';

const Footer = () => {
  const api = useApi();
  const [hotlines, setHotlines] = useState([]);
  const [settings, setSettings] = useState(null);
  const [mediaCorner, setMediaCorner] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [hotlinesData, settingsData, mediaCornerData] = await Promise.all([
          api.getHotlines(),
          api.getSettings(),
          api.getRecentMediaCorner(2)
        ]);
        
        setHotlines(hotlinesData);
        setSettings(settingsData);
        setMediaCorner(mediaCornerData || []);
      } catch (err) {
        console.error('❌ Error fetching data:', err);
      }
    };
    fetchData();
  }, [api]);

  // Helper to render the specific icon and style based on hotline code
  const renderHotlineIcon = (code) => {
    switch (code) {
      case "333":
        return (
          <div className="w-12 h-12 bg-purple-600 rounded-lg flex items-center justify-center flex-shrink-0 relative">
            <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
              <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
            </svg>
            <div className="absolute -top-1 -right-1 bg-white rounded-full w-5 h-5 flex items-center justify-center shadow-md">
              <span className="text-[9px] font-bold text-purple-600">333</span>
            </div>
          </div>
        );
      case "999":
        return (
          <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center flex-shrink-0">
            <svg className="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" />
            </svg>
          </div>
        );
      case "109":
        return (
          <div className="w-12 h-12 bg-yellow-500 rounded-lg flex items-center justify-center flex-shrink-0">
            <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
            </svg>
          </div>
        );
      case "106":
        return (
          <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0 transform rotate-45">
            <svg className="w-6 h-6 text-yellow-400 transform -rotate-45" fill="currentColor" viewBox="0 0 24 24">
              <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
            </svg>
          </div>
        );
      case "1090":
        return (
          <div className="w-12 h-12 bg-purple-600 rounded-lg flex items-center justify-center flex-shrink-0 relative">
            <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24">
              <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
            </svg>
            <div className="absolute top-0 right-0 w-4 h-4 bg-green-500 rounded-full opacity-75"></div>
          </div>
        );
      default:
        return <div className="w-12 h-12 bg-gray-600 rounded-lg flex-shrink-0"></div>;
    }
  };

  return (
    <footer className="bg-gray-900 text-white mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-6 relative">
          {/* Vertical Separator Lines */}
          <div className="hidden md:block absolute left-1/3 top-0 bottom-0 w-px bg-white opacity-20"></div>
          <div className="hidden md:block absolute left-2/3 top-0 bottom-0 w-px bg-white opacity-20"></div>

          {/* About Us */}
          <div>
            <h4 className="text-lg font-bold mb-4 uppercase">ABOUT US</h4>
            <p className="text-sm text-white leading-relaxed mb-4">
              {settings?.aboutUs || `The Directorate of Social Security Audit. The Directorate started its operation on
              23-12-2019. The Directorate is one of seventeen audit directorates under the
              Comptroller and Auditor General of Bangladesh. The Directorate is entrusted to audit all Budgetary Central Government and Statutory Public Authorities including projects, programs and schemes belonging to seven ministries: Ministry of Disaster Management & Relief, Ministry of Social Welfare, Ministry of Youth & Sports, Ministry of Women & Children Affairs, Ministry of Labor & Employment, Ministry of Food, and Ministry of Liberation War Affairs.`}
            </p>
            <div className="flex gap-3">
              {settings?.socialLinks?.facebook && (
                <a
                  href={settings.socialLinks.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors"
                >
                  <span className="text-lg font-bold">f</span>
                </a>
              )}
              {settings?.socialLinks?.youtube && (
                <a
                  href={settings.socialLinks.youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                  className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                </a>
              )}
              {settings?.socialLinks?.website && (
                <a
                  href={settings.socialLinks.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Website"
                  className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors"
                >
                  <span className="text-lg font-bold">W</span>
                </a>
              )}
            </div>
          </div>

          {/* Media Corner */}
          <div>
            <h4 className="text-lg font-bold mb-4 uppercase">MEDIA CORNER</h4>
            <div className="space-y-3">
              {mediaCorner.length > 0 ? (
                mediaCorner.map((item) => (
                  <Link
                    key={item._id}
                    to={`/media-corner/${item.slug || item._id}`}
                    className="flex gap-3 items-center justify-center group cursor-pointer"
                  >
                    <div className="relative flex-shrink-0 transition-all duration-300 ease-in-out group-hover:transform group-hover:scale-105">
                      <div className="w-28 h-28 border border-gray-200 flex items-center justify-center relative overflow-hidden rounded transition-all duration-300 group-hover:shadow-lg group-hover:shadow-blue-500/50">
                        <div className="absolute inset-0 flex items-center justify-center">
                          <img
                            src={item.imageUrl || "/assets/images/demo.jpg"}
                            alt={item.title}
                            className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                            onError={(e) => {
                              e.target.src = '/assets/images/demo.jpg';
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="text-left w-full text-sm font-semibold text-white leading-tight block transition-all duration-300 group-hover:text-blue-600 group-hover:underline">
                        {item.title}
                      </div>
                    </div>
                  </Link>
                ))
              ) : (
                <div className="text-gray-400 text-sm">No media corner items available</div>
              )}
            </div>
          </div>

          {/* Emergency Hotline */}
          <div>
            <h4 className="text-lg font-bold mb-4 uppercase">EMERGENCY HOTLINE</h4>
            <div className="space-y-3">
              {hotlines.length > 0 ? (
                hotlines.map((hotline) => (
                  <div key={hotline._id} className="flex items-center gap-3">
                    {renderHotlineIcon(hotline.code)}
                    <div className="text-sm text-white">
                      <p className="font-semibold">{hotline.number}</p>
                      <p className="text-xs">{hotline.name}</p>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-gray-400 text-sm">Loading hotlines...</div>
              )}
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-gray-700 pt-4 flex flex-col md:flex-row justify-center items-center gap-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-6 relative">
            <div className="text-sm text-white text-center">
              <p>{settings?.copyrightText || '© 2023 All rights reserved to the Foreign Aided Projects Audit Directorate.'}</p>
            </div>
            <div className="text-sm text-white text-center">
              <p className="mt-1">
                <a
                  target="_blank"
                  href="https://esoft.com.bd/"
                  rel="noopener noreferrer"
                  className="hover:text-blue-300"
                >
                  Website Design Company :
                </a>{' '}
                <span className="text-red-600 hover:text-red-300">e-soft</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
